import React from "react";
import { Carousel } from "react-bootstrap";
import "../Banner/banner.css";

const Banner = () => {
  const videoUrl = "https://ik.imagekit.io/omapadrvu/Gosehari/freecompress-Explore-Thailand-Video.mp4?updatedAt=1754300988834";

  return (
    <section className="slider">
      {/* <Carousel variant="dark">
        <Carousel.Item> */}
          <div className="video-wrapper">
            <video
              className="d-block w-100"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="overlay"></div>
          </div>
          {/* <Carousel.Caption>
            <div className="slider_des">
              <h5 className="heading">
                JOURNEY TO <span>EXPLORE WORLD</span>
              </h5>
              <p className="sub_text">
                Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the industry's
                standard dummy text ever since the 1500s,
              </p>
            </div>
          </Carousel.Caption> */}
        {/* </Carousel.Item>

      </Carousel> */}
    </section>
  );
};

export default Banner;
